export default (theme) => ({
  container: {
    padding: 5,
  },
  paper: {
    background: theme.palette.background.default,
  },
});
